const severityConfig = {
	high: { color: '#F44336' },
	medium: { color: '#FF9B21' },
	low: { color: '#2563eb' },
}

const RISK_ALERT_TYPE_PREFIX = 'riskalert-'

export const isRiskAlertNotification = (notification) => {
	const type = (notification?.type || '').toString().toLowerCase()
	return type.startsWith(RISK_ALERT_TYPE_PREFIX)
}

export const getRiskAlertSeverity = (notification) => {
	if (!isRiskAlertNotification(notification)) return 'medium'
	const type = (notification?.type || '').toString().toLowerCase()
	const parts = type.split('-')
	const level = parts[1]
	if (level === 'red') return 'high'
	if (level === 'yellow') return 'medium'
	if (level === 'green') return 'low'
	return 'medium'
}

export const getRiskAlertIcon = (severity) => {
	const color = severityConfig[severity]?.color || severityConfig.medium.color
	return (
		<div
			style={{
				width: '20px',
				height: '20px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
			dangerouslySetInnerHTML={{
				__html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
					<path d="M10 7.5V11.6667" stroke="${color}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M9.99956 17.8414H4.94956C2.05789 17.8414 0.849558 15.7747 2.24956 13.2497L4.84956 8.56641L7.29956 4.16641C8.78289 1.49141 11.2162 1.49141 12.6996 4.16641L15.1496 8.57474L17.7496 13.2581C19.1496 15.7831 17.9329 17.8497 15.0496 17.8497H9.99956V17.8414Z" stroke="${color}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M9.99512 14.168H10.0026" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>`,
			}}
		/>
	)
}

export const getNotificationIcon = (notification) => {
	const type = (notification?.type || '').toString().toLowerCase()
	const message = (notification?.message || '').toLowerCase()

	const isRiskAlert = isRiskAlertNotification(notification)
	const isPayment =
		/pay/i.test(type) || /pay/i.test(message) || /payment/i.test(type)
	const isProposal = /proposal/i.test(type)
	const isMessage = /message/i.test(type) || /chat/i.test(type)

	if (isRiskAlert) {
		const severity = getRiskAlertSeverity(notification)
		return getRiskAlertIcon(severity)
	} else if (isPayment) {
		return <img src="/images/tick-circle.svg" alt="Payment" />
	} else if (isProposal) {
		return <img src="/images/proposal-icon.svg" alt="Proposal" />
	} else if (isMessage) {
		return <img src="/images/chat-icon.svg" alt="Message" />
	}

	return <img src="/images/chat-icon.svg" alt="Notification" />
}

export const getNotificationIconType = (notification) => {
	const type = (notification?.type || '').toString().toLowerCase()
	const message = (notification?.message || '').toLowerCase()

	const isRiskAlert = isRiskAlertNotification(notification)
	const isPayment =
		/pay/i.test(type) || /pay/i.test(message) || /payment/i.test(type)
	const isProposal = /proposal/i.test(type)
	const isMessage = /message/i.test(type) || /chat/i.test(type)

	if (isRiskAlert) return 'alert'
	if (isPayment) return 'payment'
	if (isProposal) return 'proposal'
	if (isMessage) return 'message'
	return 'default'
}
